const constants = {
  links: {
    loginLink: 'https://app.bookmemate.com/login.html',
    signupLink: 'https://app.bookmemate.com/login.html#param=register',
    facebook: 'https://www.facebook.com/Bookmemate',
    messenger: 'https://www.facebook.com/messages/t/Bookmemate',
    instagram: 'https://www.instagram.com/bookmemate/',
    twitter: 'https://twitter.com/Bookmemate',
    linkedIn: 'https://www.linkedin.com/company/bookmemate/',
  },
  internalLinks: {
    clients: '/clients/',
    financial: '/financial-overview/',
    invoices: '/invoices/',
    quotes: '/quotes/',
    scheduling: '/scheduling/',
    services: '/services/',
  },
}

export default constants
